import { isPlainObj } from './check';
export var clone = function (values) {
    if (Array.isArray(values)) {
        var res_1 = [];
        values.forEach(function (item) {
            res_1.push(clone(item));
        });
        return res_1;
    }
    else if (isPlainObj(values)) {
        // React Node
        if ('$$typeof' in values && '_owner' in values) {
            return values;
        }
        // Moment Object
        if (values['_isAMomentObject']) {
            return values;
        }
        var res = {};
        for (var key in values) {
            if (Object.hasOwnProperty.call(values, key)) {
                res[key] = clone(values[key]);
            }
        }
        return res;
    }
    else {
        return values;
    }
};
